<template>
  <sistema>
    <container :isModal="false" :loading="!stateReady">
      <template v-slot:header>
        <h3>Faturamento</h3>
      </template>
      <template v-slot:body>
        <div>
          <form @submit.prevent="submitSearch">
            <entity-selector-cliente
              :cliente="cliente"
              :idClienteFiltered="filter.idCliente"
              :canEdit="true"
              @confirm-selection="confirmSelectionCliente"
              :focus="true"
              :parentLoading="stateLoading"
              style="margin-bottom: -6px !important;"
            />
            <fieldset :disabled="stateBlocked">
              <div class="p-formgrid p-grid">
                <div class="p-field p-fluid p-col-12 p-md-4 p-lg-12">
                  <entity-selector-transportador
                    :cliente="cliente"
                    :idTransportadorFiltered="filter.idTransportador"
                    @confirm-selection="confirmSelectionTransportador"
                    :focus="!amIAllowed('view', 'root-cliente')"
                    :required="false"
                  />
                </div>
              </div>
              <div class="p-formgrid p-grid">
                <div class="p-field p-fluid p-col-12 p-md-4 p-lg-4">
                  <input-with-label
                    label="Número AET"
                    v-slot="l"
                    style="white-space: pre-line"
                  >
                    <InputText
                      class="p-inputtext"
                      v-model="filter.numeroPedidoOrgao"
                      :id="l.id"
                      :required="l.required"
                    />
                  </input-with-label>
                </div>
                <div class="p-field p-fluid p-col-12 p-md-6 p-lg-4">
                  <input-with-label label="Situação" v-slot="l">
                    <Dropdown
                      :id="l.id"
                      :required="l.required"
                      v-model="filter.statusFatura"
                      :options="tiposDisponiveis"
                      optionValue="flag"
                      optionLabel="mensagem"
                      :placeholder="'&nbsp;'"
                      :disabled="stateBlocked"
                    />
                  </input-with-label>
                </div>
                <div class="p-field p-fluid p-col-12 p-md-6 p-lg-4">
                  <period-picker
                    v-model:start="filter.periodo"
                    v-model:type="periodoFixo"
                    :showTypeSelector="false"
                    :parentLoading="stateLoading"
                  />
                </div>
              </div>
            </fieldset>
            <button-group>
              <Button
                type="submit"
                class="p-button-rounded"
                label="Buscar"
                :disabled="stateBlocked"
              />
              <Button
                v-if="amIAllowed('view', 'root-cliente')"
                label="Buscar AETs a Faturar"
                class="p-button-rounded p-button-info"
                @click="aetsToFaturar()"
                :disabled="stateLoading"
              />
              <Button
                v-if="amIAllowed('view', 'root-cliente')"
                label="Gerar Faturamento"
                class="p-button-rounded p-button-success"
                @click="gerarFaturamento()"
                :disabled="stateLoading"
              />
              <Button
                label="Imprimir"
                class="p-button-rounded p-button"
                @click="downloadPdf()"
                :disabled="stateBlocked"
              />
            </button-group>
          </form>
        </div>
        <div>
          <fieldset>
            <div
              class="p-formgrid p-grid"
              style="width: 10%; min-width: 350px;"
            >
              <div v-if="descricaoBusca" class="p-lg-2" style="flex: 1;">
                <h4 class="p-text-bold" style="margin-bottom: 0 !important">
                  {{ descricaoBusca }}
                </h4>
                <div class="p-mt-2 p-text-secondary">
                  <li><strong>Situação:</strong></li>
                  <li><strong>FAT</strong> - Faturadas</li>
                  <li><strong>BON</strong> - Bonificadas</li>
                  <li><strong>DEL</strong> - Deletadas</li>
                </div>
              </div>
              <div v-if="descricaoBusca" class="p-mt-6 p-lg-1" style="flex: 1;">
                <div class="p-mt-1 p-text-secondary">
                  <li><strong>Tipo:</strong></li>
                  <li><strong>LIC</strong> - Licenças</li>
                  <li><strong>PRO</strong> - Projetos</li>
                </div>
              </div>
            </div>
          </fieldset>
          <DataTable
            :value="results.content"
            :loading="stateLoading"
            responsiveLayout="scroll"
            v-if="results.content.length"
          >
            <Column
              v-if="amIAllowed('view', 'root-cliente')"
              field="idLicenca"
              header="idLicenca"
            />
            <template #body="{ data }">
              {{ getIdLicenca(data) }}
            </template>
            <Column
              style="white-space: pre-line;"
              field="numeroPedidoOrgao"
              header="Nº GovPass"
            >
              <template #body="{ data }">
                {{ getNumeroPedidoOrgao(data) }}
              </template>
            </Column>
            <Column field="nomeTransportador" header="Transportador">
              <template #body="{ data }">
                {{ getNomeTransportador(data) }}
              </template>
            </Column>
            <Column field="cpfCnpj" header="CPF/CNPJ">
              <template #body="{ data }">
                {{ getCpfCnpj(data) }}
              </template>
            </Column>
            <Column field="tipoItem" header="Tipo">
              <template #body="{ data }">
                {{ getFlTipoItem(data) }}
              </template>
            </Column>
            <Column
              v-if="
                amIAllowed('view', 'root-cliente') &&
                  descricaoBusca == 'Licenças Faturadas'
              "
              field="statusFatura"
              header="Situação"
            >
              <template #body="{ data }">
                <input-with-label label="Situação" v-slot="l">
                  <Dropdown
                    style="width: 135px"
                    :id="l.id"
                    :required="l.required"
                    v-model="data.statusFaturaStr"
                    :options="tiposDisponiveisRoot"
                    optionValue="flag"
                    optionLabel="mensagem"
                    :placeholder="' '"
                    :disabled="stateBlocked"
                  />
                </input-with-label>
              </template>
            </Column>
            <Column
              v-if="
                !amIAllowed('view', 'root-cliente') ||
                  descricaoBusca == 'Licenças a Faturar'
              "
              field="statusFatura"
              header="Situação"
            >
              <template #body="{ data }">
                {{ getStatusFatura(data) }}
              </template>
            </Column>
            <Column header="Ações" v-if="amIAllowed('view', 'root-cliente')">
              <template #body="{ data }">
                <Button
                  icon="pi pi-check"
                  class="p-button-rounded p-button-success"
                  @click="() => submitSave(data)"
                />
              </template>
            </Column>
          </DataTable>
          <div v-else class="p-text-center p-mt-4">
            <p>Nenhum resultado encontrado.</p>
          </div>

          <Paginator
            :rows="15"
            :totalRecords="results.totalElements"
            :first="page * 15"
            :pageLinkSize="5"
            @page="(e) => afterPageChange(e.page)"
            class="p-mt-3 p-justify-center"
          />
        </div>
      </template>
    </container>
  </sistema>
</template>

<script lang="ts">
import {
  defineComponent,
  reactive,
  toRefs,
  onMounted,
  computed,
  Ref
} from "vue";
import EntitySelectorTransportador from "../../components/transportador/EntitySelectorTransportador.vue";
import { useAuth, PermissionPayload } from "../../modules/auth";
import { formatDate, DATE_SELECTORS } from "../../modules/utils";
import {
  useLicencaFaturamentoService,
  LicencaFaturamentoPayload,
  LicencaFaturamentoFilterPayload,
  LicencaFaturamentoFilterReturnPayload,
  TipoLicencaFaturamentoPayload
} from "../../modules/business/licenca/licencaFaturamentoBusiness";
import { ClientePayload } from "../../modules/business/cliente/clienteBusiness";
import EntitySelectorCliente from "../../components/cliente/EntitySelectorCliente.vue";
import { TransportadorPayload } from "../../modules/business/transportador/transportadorBusiness";
import { PaginationResult, defaultResults } from "../../pagination";
import { LicencaOrgaoPayload } from "../../modules/business/licenca/licencaOrgaoBusiness";
import { useToast } from "../../modules/message";

interface CombinacaoVeiculoState {
  filter: LicencaFaturamentoFilterPayload;
  cliente?: ClientePayload | null;
  stateLoading: boolean;
  stateReady: boolean;
  tiposDisponiveis: Array<TipoLicencaFaturamentoPayload>;
  tiposDisponiveisRoot: Array<TipoLicencaFaturamentoPayload>;
  periodoFixo: string;
  page: number;
  licencaOrgaoSelected: Array<number>;
  results: PaginationResult<LicencaOrgaoPayload>;
  loadings: Array<Ref<boolean>>;
  tipoPaginamento: string;
  descricaoBusca: string;
}

export default defineComponent({
  setup() {
    const state = reactive<CombinacaoVeiculoState>({
      filter: { statusFatura: "TOD" },
      cliente: null,
      stateLoading: false,
      stateReady: false,
      tiposDisponiveis: useLicencaFaturamentoService().getTiposLicencaFaturamento(),
      tiposDisponiveisRoot: [
        { mensagem: "Faturada", flag: "FAT" },
        { mensagem: "Bonificada", flag: "BON" },
        { mensagem: "Deletada", flag: "DEL" }
      ],
      periodoFixo: DATE_SELECTORS.MONTH,
      page: 0,
      licencaOrgaoSelected: [],
      results: defaultResults(),
      loadings: [],
      tipoPaginamento: "search" as "afaturar" | "faturadas",
      descricaoBusca: ""
    });

    const amIAllowed = (
      authority: string,
      permissionInfo?: PermissionPayload | string | null
    ) => {
      return useAuth().amIAllowed(authority, permissionInfo);
    };

    const stateBlocked = computed(() => {
      if (state.stateLoading) {
        return true;
      } else if (amIAllowed("view", "root-cliente")) {
        return !state.filter.idCliente;
      }
      return false;
    });

    const executeSearch = () => {
      state.stateLoading = true;
      const {
        data,
        loading,
        searchLicencaFaturamento
      } = useLicencaFaturamentoService();
      state.loadings.push(loading);
      return searchLicencaFaturamento(state.filter, state.page)
        .then(() => {
          if (data.value && data.value.content) {
            const resultTratado: LicencaFaturamentoPayload[] = data.value.content.map(
              (item: LicencaFaturamentoFilterReturnPayload, index: number) => {
                item.groupIndex = index;
                return item;
              }
            );
            data.value.content = resultTratado;
            state.results = data.value;
          } else {
            state.results = defaultResults();
          }
          state.stateLoading = false;
        })
        .catch(() => {
          state.stateLoading = false;
          state.loadings.splice(state.loadings.indexOf(loading), 1);
        });
    };

    const executeAetsToFaturar = () => {
      state.stateLoading = true;
      const {
        data,
        loading,
        searchAetsToFaturar
      } = useLicencaFaturamentoService();
      state.loadings.push(loading);
      return searchAetsToFaturar(state.page)
        .then(() => {
          if (data.value && data.value.content) {
            const resultTratado: LicencaFaturamentoPayload[] = data.value.content.map(
              (item: LicencaFaturamentoFilterReturnPayload, index: number) => {
                item.groupIndex = index;
                return item;
              }
            );
            data.value.content = resultTratado;
            state.results = data.value;
          } else {
            state.results = defaultResults();
          }
          state.stateLoading = false;
        })
        .catch(() => {
          state.stateLoading = false;
          state.loadings.splice(state.loadings.indexOf(loading), 1);
        });
    };

    const executeDownload = () => {
      state.stateLoading = true;
      const { downloadFaturamento } = useLicencaFaturamentoService();
      downloadFaturamento(state.filter)
        .then(() => {
          state.stateLoading = false;
        })
        .catch(() => {
          state.stateLoading = false;
        });
    };

    const submitSearch = () => {
      state.page = 0;
      state.tipoPaginamento = "faturadas";
      state.descricaoBusca = "Licenças Faturadas";
      return executeSearch();
    };

    const executeSave = (item: LicencaFaturamentoFilterPayload) => {
      state.stateLoading = true;
      const { salvarStatusItem } = useLicencaFaturamentoService();
      salvarStatusItem(item)
        .then(() => {
          state.stateLoading = false;
          useToast().success("AET alterada com sucesso");
        })
        .catch(() => {
          state.stateLoading = false;
          useToast().error("Falha ao salvar a AET");
        });
    };

    const submitSave = (data: LicencaFaturamentoFilterPayload) => {
      return executeSave(data);
    };

    const aetsToFaturar = () => {
      state.page = 0;
      state.tipoPaginamento = "afaturar";
      state.descricaoBusca = "Licenças a Faturar";
      return executeAetsToFaturar();
    };

    const gerarFaturamento = () => {
      return null;
    };

    const downloadPdf = () => {
      return executeDownload();
    };

    const getIdLicenca = (e?: LicencaFaturamentoPayload) => {
      return useLicencaFaturamentoService().getIdLicenca(e);
    };

    const getFlTipoItem = (e?: LicencaFaturamentoPayload) => {
      return useLicencaFaturamentoService().getFlTipoItem(e);
    };

    const getStatusFatura = (e?: LicencaFaturamentoPayload) => {
      return useLicencaFaturamentoService().getStatusFatura(e);
    };

    const getNomeTransportador = (e?: LicencaFaturamentoPayload) => {
      return useLicencaFaturamentoService().getNomeTransportador(e);
    };

    const getCpfCnpj = (e?: LicencaFaturamentoPayload) => {
      return useLicencaFaturamentoService().getCpfCnpj(e);
    };

    const getNumeroPedidoOrgao = (e?: LicencaFaturamentoPayload) => {
      return useLicencaFaturamentoService().getNumeroPedidoOrgao(e);
    };

    const blockedSelectionLicencaFaturamento = (
      itemFaturamento: LicencaFaturamentoPayload
    ) => {
      return !itemFaturamento?.idLicencaOrgao;
    };

    const afterPageChange = (page?: number) => {
      if (typeof page !== "undefined") {
        state.page = page;
      }
      if (state.tipoPaginamento == "afaturar") {
        executeAetsToFaturar();
      } else {
        executeSearch();
      }
    };

    const confirmSelectionFaturamento = (
      selected: Array<LicencaFaturamentoPayload>,
      added: Array<LicencaFaturamentoPayload>,
      removed: Array<LicencaFaturamentoPayload>
    ) => {
      if (added && added.length > 0) {
        added.forEach((lic) => {
          if (
            lic.idLicencaOrgao &&
            state.licencaOrgaoSelected.indexOf(lic.idLicencaOrgao) < 0
          ) {
            state.licencaOrgaoSelected.push(lic.idLicencaOrgao);
          }
        });
      }
      if (removed && removed.length > 0) {
        removed.forEach((lic) => {
          if (
            lic.idLicencaOrgao &&
            state.licencaOrgaoSelected.indexOf(lic.idLicencaOrgao) >= 0
          ) {
            state.licencaOrgaoSelected.splice(
              state.licencaOrgaoSelected.indexOf(lic.idLicencaOrgao),
              1
            );
          }
        });
      }
      return selected;
    };

    const confirmSelectionCliente = (c?: ClientePayload) => {
      state.filter.idCliente = c && c.idCliente ? c.idCliente : undefined;
      state.cliente = c;
      state.filter = { idCliente: state.filter.idCliente, statusFatura: "TOD" };
    };

    const confirmSelectionTransportador = (t?: TransportadorPayload) => {
      state.filter.idTransportador =
        t && t.idTransportador ? t.idTransportador : undefined;
    };

    onMounted(async () => {
      state.stateReady = true;
    });

    return {
      getIdLicenca,
      getFlTipoItem,
      getStatusFatura,
      getNomeTransportador,
      getCpfCnpj,
      getNumeroPedidoOrgao,
      submitSearch,
      //submitSave,
      aetsToFaturar,
      gerarFaturamento,
      downloadPdf,
      blockedSelectionLicencaFaturamento,
      afterPageChange,
      confirmSelectionFaturamento,
      amIAllowed,
      confirmSelectionCliente,
      confirmSelectionTransportador,
      formatDate,
      submitSave,
      stateBlocked,
      ...toRefs(state)
    };
  },
  components: {
    EntitySelectorTransportador,
    EntitySelectorCliente
  }
});
</script>
